
import "./footer.css";

import { useState, useEffect } from "react";

/* navegação */
import { Link } from "react-router-dom";

/* autenticação */
import { auth } from "../../services/firebaseConnection";
import { signOut } from "firebase/auth";

/* funções auxiliares */
import { registerLog, db_basic } from "../../services/functions/functions.ts";



export default function Footer({access}) {

    const [basic, setBasic] = useState([]);
    const [chatOpen, setChatOpen] = useState(false);

    async function logout() {

        await signOut(auth);
        registerLog(basic.user.id, "/logout");

    }

    useEffect(() => {
    
        const loadBasic = async () => {
            
            const uid = auth.currentUser?.uid;

            if(!uid) return;

            const bbd = await db_basic(uid);
            setBasic(bbd);
        };

        loadBasic();

    }, []);




    function SupportChat() {
        return (
            <iframe
            src="https://app.gptmaker.ai/widget/3EFFB416257393E9DF89FE8BA71AB4AF/iframe"
            style={{ width:"100%", height:"100%", border:"none"}}
            allow="microphone;"
            title="Chat Suporte" />
        );
    }

 


    return(
        <div className="footer">
            <div className="footer_content">
                <div className="footer_contato">
                    <div className="footer_contato_box">
                        <span className="footer_contato_box_title">Quer saber sobre nós?</span>
                        <Link to="/whoweare" className="footer_contato_box_item">Quem Somos</Link>
                    </div>
                    <div className="footer_contato_box">
                        <span className="footer_contato_box_title">Conheça nosso:</span>
                        <a href="/terms" target="_blank" rel="noopener noreferrer" className="footer_contato_box_item">Termos de Uso</a>
                    </div>
                    <div className="footer_contato_box">
                        <span className="footer_contato_box_title">Contato:</span>
                        <a href="mailto:suporte@winners-ia.com" className="footer_contato_box_item">suporte@winners-ia.com</a>
                    </div>
                    <div className="footer_contato_box">
                        <span className="footer_contato_box_title">Dúvidas???</span>
                        <span className="footer_contato_box_item" onClick={() => setChatOpen(true)}>Fale com nosso Agente</span>
                    </div>
                </div>
                <span className="footer_line"></span>
                <div className="footer_links">
                    { access === 0 ? (
                    <>
                    <div className="footer_links_box">
                        <span className="footer_links_title">Links:</span>
                    </div>
                    <div className="footer_links_box">
                        <Link to="/" className="footer_links_item">Página Inicial</Link>
                    </div>
                    <div className="footer_links_box">
                        <Link to="/howitworks" className="footer_links_item">Como Funciona</Link>
                        <Link to="/subscription" className="footer_links_item">Planos</Link>
                    </div>
                    <div className="footer_links_box">
                        <Link to="/login" className="footer_links_item">Entrar</Link>
                    </div>
                    </>
                    ) : (
                    <>
                    <div className="footer_links_box">
                        <span className="footer_links_title">Links:</span>
                    </div>
                    <div className="footer_links_box">
                        <Link to="/panel" className="footer_links_item">Painel do Cliente</Link>
                    </div>
                    <div className="footer_links_box">
                        <Link to="/agent" className="footer_links_item">Configure seu agente</Link>
                        <Link to="/schedule" className="footer_links_item">Agenda</Link>
                        <Link to="/performance" className="footer_links_item">Perfomance do agente</Link>
                        <Link to="/billing" className="footer_links_item">Planos e pagamentos</Link>
                        <Link to="/account" className="footer_links_item">Configurações</Link>
                    </div>
                    <div className="footer_links_box">
                        <Link to="/login" className="footer_links_item" onClick={ logout }>Sair</Link>
                    </div>
                    </>
                    )}
                </div>
            </div>
            <div className="footer_infos">
                <span className="footer_infos_direitos">&copy;&nbsp;Todos os direitos reservados a winners-ai</span>
                <span className="footer_infos_cnpj">Cnpj 10.214.659/0001-02</span>
                <span className="footer_infos_versao">Plataforma v5.30-260818</span>
            </div>
            {chatOpen && (
                <div className="footer_chat_overlay">
                <div className="footer_chat_modal">
                <div className="footer_chat_header">
                    <span>Suporte Winners AI</span><button onClick={() => setChatOpen(false)}>✕</button>
                </div>
                <SupportChat />
                </div>
                </div>
            )}
        </div>
    )
}